<template>
  <div>
    <h2>DashboardSubpage</h2>
  </div>
</template>

<script>
export default {
  name: "DashboardSubpage",
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  components: {
  }
};
</script>

<style>
</style>
